export const ADD_COMMESSA = 'ADD_COMMESSA';
export const UPDATE_COMMESSA = 'UPDATE_COMMESSA';

export const FETCH_COMMESSE = 'FETCH_COMMESSE';